import Seo from "./Seo";
import { Link } from "react-router-dom";
import { BUSINESS, organizationJsonLd } from "./business";

export default function About() {
  return (
    <>
      <Seo
        title="About Us — DueMate"
        description={`DueMate (${BUSINESS.legalName}) is a Udyam-registered Indian SaaS operated by ${BUSINESS.ownerName} in Cansaulim, Goa. We help small service businesses manage customer service reminders, due dates and follow-ups.`}
        jsonLd={organizationJsonLd()}
      />
      <section className="max-w-[900px] mx-auto px-4 sm:px-6 py-12">
        <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#4361EE]">About Us</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter mt-2">Small service businesses run on repeat visits.</h1>
        <p className="text-base text-[#4A4A4A] font-semibold mt-5">
          But repeat visits only happen if the customer remembers — and most of the time, they don&apos;t.
        </p>

        <div className="nb-card p-6 sm:p-8 mt-8 space-y-4">
          <h2 className="font-heading text-2xl font-black">What DueMate is</h2>
          <p className="text-sm sm:text-base font-semibold text-[#111111] leading-relaxed">
            DueMate is a software platform designed to help service businesses keep track of customer service due dates, reminders and follow-ups.
          </p>
          <p className="text-sm sm:text-base font-semibold text-[#111111] leading-relaxed">
            Whether you run a car garage, dental clinic, salon, RO service, pet grooming studio, or another service business, DueMate keeps track of every customer&apos;s next-service date and helps you send timely reminders via WhatsApp — so you spend less time chasing and more time serving.
          </p>
        </div>

        <div className="nb-card p-6 sm:p-8 mt-6 space-y-4">
          <h2 className="font-heading text-2xl font-black">Who we are</h2>
          <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-3 text-sm sm:text-base">
            <div>
              <dt className="text-[10px] font-bold tracking-[0.15em] uppercase text-[#4A4A4A]">Legal name</dt>
              <dd className="font-heading font-black text-lg leading-tight">{BUSINESS.legalName}</dd>
            </div>
            <div>
              <dt className="text-[10px] font-bold tracking-[0.15em] uppercase text-[#4A4A4A]">Operated by</dt>
              <dd className="font-bold">{BUSINESS.ownerName}</dd>
            </div>
            <div>
              <dt className="text-[10px] font-bold tracking-[0.15em] uppercase text-[#4A4A4A]">Organization type</dt>
              <dd className="font-bold">{BUSINESS.organizationType}</dd>
            </div>
            <div>
              <dt className="text-[10px] font-bold tracking-[0.15em] uppercase text-[#4A4A4A]">Udyam Registration</dt>
              <dd className="font-mono font-bold">{BUSINESS.udyamNumber}</dd>
            </div>
            <div>
              <dt className="text-[10px] font-bold tracking-[0.15em] uppercase text-[#4A4A4A]">Registered address</dt>
              <dd className="font-semibold">{BUSINESS.address.formatted}</dd>
            </div>
            <div>
              <dt className="text-[10px] font-bold tracking-[0.15em] uppercase text-[#4A4A4A]">Registered since</dt>
              <dd className="font-semibold">{BUSINESS.foundedDisplay}</dd>
            </div>
          </dl>
          <p className="text-xs font-semibold text-[#4A4A4A] pt-3 border-t-2 border-dashed border-black/15">
            Registered under the Ministry of MSME, Government of India, as a proprietorship enterprise offering computer programming, consultancy and related IT services.
          </p>
        </div>

        <div className="nb-card p-6 sm:p-8 mt-6 space-y-3 bg-[#FFD166]/60">
          <h2 className="font-heading text-2xl font-black">Get in touch</h2>
          <p className="text-sm sm:text-base font-semibold">
            Questions, feedback, or want to know if DueMate fits your business? <Link to="/contact" className="underline">Contact us</Link> — we read every message. Email <a href={`mailto:${BUSINESS.email}`} className="underline">{BUSINESS.email}</a> or call <a href={`tel:${BUSINESS.phone}`} className="underline">{BUSINESS.phoneDisplay}</a>.
          </p>
        </div>
      </section>
    </>
  );
}
